import { ref, watch } from 'vue'
import { type ZodTypeAny, z } from 'zod'

export function useValidator<T extends ZodTypeAny>(
  schema: T,
  data?: Partial<z.infer<T>>,
  options?: { eager?: boolean }
) {
  type SchemaType = z.infer<T>

  const formData = ref({ ...data } as SchemaType)
  const formError = ref<Partial<Record<keyof SchemaType, string>> | Record<string, never>>({})

  const validate = () => {
    try {
      schema.parse(formData.value)
      formError.value = {}

      return true
    } catch (error: unknown) {
      if (error instanceof z.ZodError) {
        formError.value = Object.fromEntries(
          Object.entries(error.flatten().fieldErrors).map(([key, value]) => [
            key,
            Array.isArray(value) ? value.join(', ') : value
          ])
        )
      }

      return false
    }
  }

  if (options && options.eager) {
    watch(formData, () => validate(), { deep: true })
  }

  return {
    formData,
    formError,
    validate
  }
}
